import React from 'react'

function CRMActivity() {
  return (
    <div className='rounded-lg bg-white p-3'>Activity</div>
  )
}

export default CRMActivity